import React, { useRef, useState } from "react";
import { Button, Modal } from "antd";
import { WarningFilled } from "@ant-design/icons";
import CompanyShareholderScreen from "views/company/company-shareholder-screen";
import { themeColors } from "theme";
import { useShareholderStatus } from "hooks/useShareholderStatus";

const ValidateLegalRepresentativeButton = ({
    companyId, onStatusChange
}) => {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const hasAutoOpened = useRef(false);
    const { shareholders, companyData, blocked, refresh } = useShareholderStatus();

    const fakeFormCompany = React.useMemo(
        () => ({
            validateFields: async () => {
                if (!companyData) {
                    throw new Error("Dados da empresa não carregados");
                }
                return companyData;
            }
        }),
        [companyData]
    );

    React.useEffect(() => {
        hasAutoOpened.current = false;
        refresh(companyId).then(({ hasIssues, allowCompany }) => {
            onStatusChange?.(allowCompany ? false : hasIssues);
            if (hasIssues && !allowCompany && !hasAutoOpened.current) {
                hasAutoOpened.current = true;
                setOpen(true);
            }
        });
    }, [companyId]);

    if (!blocked) {
        return null;
    }

    return (
        <>
            <Button
                danger
                style={{ borderColor: "transparent", backgroundColor: themeColors.softColor, height: 43 }}
                disabled={!companyData}
                icon={<WarningFilled />}
                onClick={() => setOpen(true)}
            ><span style={{ color: themeColors.mediumColor }}>Validar Representante Legal</span>
            </Button>

            <Modal
                open={open}
                footer={null}
                width={1400}
                destroyOnClose
                onCancel={() => setOpen(false)}
                title={
                    <div>
                        <div style={{ fontWeight: 600, fontSize: 18 }}>
                            Validação de dados: Sócios e Representantes Legais
                        </div>
                        <div style={{ fontSize: 14, fontWeight: "normal", marginTop: 10, marginBottom: -10 }}>
                            Ainda existem sócios/representantes legais com validação de dados pendente.
                        </div>
                    </div>
                }
            >
                <CompanyShareholderScreen
                    loading={loading}
                    company={companyId}
                    formCompany={fakeFormCompany}
                />
            </Modal>
        </>
    );
};

export default ValidateLegalRepresentativeButton;